import DashboardDealList from "./DashboardDealList";

export default DashboardDealList;
